module.exports = __webpack_public_path__ + "static/images/food.3e8N_ji.svg";